import { useCallback } from 'react';

const CARDS = [
  {
    tag: '动作',
    title: '国产动作片崛起：从功夫到科幻的进化之路',
    desc: '盘点近年来国产动作电影的里程碑作品，从传统武术到硬核科幻，中国电影工业正在书写新的篇章。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20action%20film%20scene%20with%20martial%20arts%20and%20modern%20combat%2C%20dramatic%20cinematic%20lighting%20with%20dust%20and%20motion%2C%20epic%20film%20production%20atmosphere%20with%20stunt%20choreography%2C%20dark%20theater%20style%20visual%20with%20gold%20accents&width=500&height=320&seq=card-01&orientation=landscape',
  },
  {
    tag: '科幻',
    title: '《流浪地球》系列如何重新定义中国科幻',
    desc: '从第一部到第三部，流浪地球系列用硬核科幻和东方叙事征服全球观众，开启中国科幻电影新纪元。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20exploration%20scene%20with%20Earth%20and%20stars%2C%20cinematic%20sci-fi%20lighting%20with%20blue%20and%20gold%20tones%2C%20epic%20spacecraft%20and%20planet%20visuals%2C%20grand%20scale%20science%20fiction%20film%20atmosphere%20on%20dark%20background&width=500&height=320&seq=card-02&orientation=landscape',
  },
  {
    tag: '悬疑',
    title: '烧脑神作盘点：那些让你猜不到结局的电影',
    desc: '精选国内外高智商悬疑电影，每一部都值得反复观看，每一个细节都暗藏玄机。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20film%20noir%20scene%20with%20shadowy%20detective%20office%2C%20dramatic%20lighting%20through%20venetian%20blinds%2C%20suspense%20thriller%20atmosphere%20with%20clues%20and%20evidence%2C%20dark%20cinematic%20mood%20with%20warm%20amber%20and%20deep%20shadows&width=500&height=320&seq=card-03&orientation=landscape',
  },
  {
    tag: '动画',
    title: '国产动画电影十年：从《大圣归来》到《哪吒》',
    desc: '回顾中国动画电影的黄金十年，技术与故事的双重突破让国漫走向世界舞台。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20visual%20with%20mythological%20characters%20and%20vibrant%20colors%2C%20artistic%20rendering%20style%20with%20traditional%20Chinese%20aesthetics%2C%20animated%20film%20production%20atmosphere%20with%20storyboard%20elements%2C%20magical%20and%20epic%20visuals&width=500&height=320&seq=card-04&orientation=landscape',
  },
  {
    tag: '电视剧',
    title: '2026暑期档剧集指南：这些好剧不容错过',
    desc: '从古装权谋到现代都市，暑期档热门剧集一网打尽，追剧清单速速收藏。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Television%20drama%20collage%20with%20various%20Chinese%20period%20and%20modern%20costume%20scenes%2C%20warm%20home%20entertainment%20atmosphere%20with%20glowing%20TV%20screen%2C%20cozy%20viewing%20experience%20with%20golden%20lighting%2C%20drama%20series%20promotional%20aesthetic&width=500&height=320&seq=card-05&orientation=landscape',
  },
];

export default function SectionCards() {
  const handleImgError = useCallback((e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.setAttribute('data-failed', 'true');
  }, []);

  return (
    <section id="cards" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
            精选专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            深度影视内容，带你了解更多好片背后的故事
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {CARDS.slice(0, 3).map((card) => (
            <div
              key={card.title}
              className="group rounded-xl overflow-hidden bg-background-200/60 border border-background-300/40 hover:border-background-300/70 transition-all cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={handleImgError}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-0.5 rounded-md text-xs font-semibold bg-primary-500/80 text-background-50">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-100 group-hover:text-primary-400 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {CARDS.slice(3).map((card) => (
            <div
              key={card.title}
              className="group rounded-xl overflow-hidden bg-background-200/60 border border-background-300/40 hover:border-background-300/70 transition-all cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative h-36 sm:h-auto sm:w-48 shrink-0 overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={handleImgError}
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md text-xs font-semibold bg-secondary-500/80 text-background-50">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex-1">
                <h3 className="text-sm md:text-base font-bold text-foreground-100 group-hover:text-primary-400 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}